import React from "react";

<svg width="49" height="50" viewBox="0 0 49 50" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21.2838 41.7664L22.9525 48.0085C23.3657 49.5544 25.56 49.5544 25.9731 48.0085L27.6418 41.7664C29.4551 35.0423 34.6838 29.7952 41.3574 28.0026L47.5995 26.3224C49.142 25.907 49.142 23.7184 47.5995 23.303L41.3574 21.6228C34.6574 19.8038 29.4287 14.5556 27.6418 7.859L25.9731 1.61691C25.56 0.07102 23.3657 0.0710198 22.9525 1.61691L21.2838 7.85899C19.4705 14.5831 14.2418 19.8302 7.56823 21.6228L1.32614 23.303C-0.216303 23.7184 -0.216303 25.907 1.32614 26.3224L7.56823 28.0026C14.2418 29.7952 19.4717 35.0423 21.2838 41.7664Z" fill="#52288E"/>
</svg>


//"#52288E"
const getPath = ({ fillColor }) => {
  return (
<path d="M21.2838 41.7664L22.9525 48.0085C23.3657 49.5544 25.56 49.5544 25.9731 48.0085L27.6418 41.7664C29.4551 35.0423 34.6838 29.7952 41.3574 28.0026L47.5995 26.3224C49.142 25.907 49.142 23.7184 47.5995 23.303L41.3574 21.6228C34.6574 19.8038 29.4287 14.5556 27.6418 7.859L25.9731 1.61691C25.56 0.07102 23.3657 0.0710198 22.9525 1.61691L21.2838 7.85899C19.4705 14.5831 14.2418 19.8302 7.56823 21.6228L1.32614 23.303C-0.216303 23.7184 -0.216303 25.907 1.32614 26.3224L7.56823 28.0026C14.2418 29.7952 19.4717 35.0423 21.2838 41.7664Z" fill={fillColor || "#52288E"} />
  );
};

const Sparkle = ({fillColor, width = 49, height = 50, className}) => (
  <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49 50" xmlnsXlink="http://www.w3.org/1999/xlink" className={className}>
    {getPath({fillColor})}
  </svg>
);

export default Sparkle;
